import { Component, OnInit } from "@angular/core";
import { CourseResponse } from "src/app/interfaces/response";

@Component({
  selector: "app-renac-home",
  templateUrl: "./renac-home.component.html",
  styleUrls: ["./renac-home.component.css"],
})
export class RenacHomeComponent {
  selectedCourse: CourseResponse | null = null;
  idCorso: number | null;

  public onCourseSelected(course: any): void {
    this.selectedCourse = course;
    this.idCorso = course.idCurso;
    window.scroll(0, 0);
  }

  public closeDetail(): void {
    this.selectedCourse = null;
  }
}
